import React from "react";
import { toast } from "react-toastify";

function LinkedLecturePopup({
  setClickOpenUp,
  handleAddToSessionButton,
  setClick,
  isPastLecture,
}) {
  return (
    <div className="published_Deative_transprant_body">
      <div className="published_Deative_preview_container">
        <img
          className="deactive_closeBtn"
          src="/images/cross-circle3.svg"
          alt=""
          onClick={() => setClickOpenUp(false)}
        />
        <div className="col-12 deactivate_msg">
          {`This supplement is already associated with a Lecture. Reassigning it will remove it from that lecture.`}
        </div>
        <div className="col-12 deactivate_msg">
          {`Do you want to continue?`}
        </div>
        <div className="row col-12 publish_deactive_btnBox">
          <button
            className="btn col-sm-5 my-1 deactive_sure_btn"
            onClick={() => {
              // if (isPastLecture) {
              //     toast.error("Lecture Session already completed!!")
              //     setClick({ addMaterial: true })
              //     setClickOpenUp(false)
              // } else {
              handleAddToSessionButton();
              setClick({ addMaterial: false });
              //}
            }}
          >
            Yes
          </button>
          <button
            className="btn col-sm-5 my-1 deactive_sure_btn"
            onClick={() => setClickOpenUp(false)}
          >
            No
          </button>
        </div>
      </div>
    </div>
  );
}

export default LinkedLecturePopup;
